<script setup lang="ts">
import ConfirmHost from './components/ConfirmHost.vue';
import ToastHost from './components/ToastHost.vue';
import { loading } from './services/notify';
</script>

<template>
  <div v-if="loading.visible" class="creator-loading-bar" role="progressbar" :aria-label="$t('app.loading')"></div>
  <RouterView />
  <ToastHost />
  <ConfirmHost />
</template>
